<app-page pageTitle="About">
  <div class="about-container">
    <app-labeled-container class="width-100" label="General">
      @for (item of general; track $index; let last = $last) {
      <app-category-item
        [label]="item.label"
        [icon]="item.icon"
        [value]="item.value"
        [underlined]="!last"
        (click)="navigateTo(item.route, item.params)"
      />
      }
    </app-labeled-container>
    <app-labeled-container class="width-100" label="FAQ">
      @for (item of faq; track $index; let last = $last) {
      <app-category-item
        [label]="item.label"
        [icon]="item.icon"
        [value]="item.value"
        [underlined]="!last"
        (click)="navigateTo(item.route, item.params)"
      />
      }
    </app-labeled-container>
    @if (globalService.theme() === 'dark') {
    <img src="../../../assets/dark/APA_Logo.svg" style="width: 40%; height: auto; max-width: 200px" />
    } @else {
    <img src="../../../assets/light/APA_Logo.svg" style="width: 40%; height: auto; max-width: 200px" />
    }
    <div style="color: var(--text-color-secondary); font-size: 0.8rem">IMAX Version {{ version }}</div>
  </div>
</app-page>
